"use client";

import staticData from "@/public/data/landing.json";
import { cn } from "@/shared/libs/commonUtils";
import { useGlobalStore } from "@/shared/stores/global-store/GlobalStoreProvider";
import Link from "next/link";
import { usePathname } from "next/navigation";
import Flex from "./Flex";
import List from "./List";
import PhosphorIcon from "./PhosphorIcon";
import Typography from "./Typography";
import { isActivePath } from "@/shared/libs/url-utils";

interface NavbarProps {
  isUserLogin: boolean;
  className?: string;
}

export default function Navbar({ isUserLogin, className }: NavbarProps) {
  const { activeRoutes, items } = staticData.navbar;

  if (!isActivePath(activeRoutes, usePathname())) return null;

  const activeRoute = items.find(({ activeRoutes }) =>
    activeRoutes.includes(usePathname()),
  )?.id;

  const { setIsLoginModalOn } = useGlobalStore((state) => state);

  const handleChangeBar = (requiresAuth: boolean) => () => {
    if (requiresAuth && !isUserLogin) {
      setIsLoginModalOn(true);
    }
  };

  return (
    <Flex
      justifyContent={"evenly"}
      alignItems={"center"}
      gap={"1"}
      className={`bg-background border-t border border-border h-auto text-background w-full sticky bottom-0 py-2 shadow-lg ${className}`}
    >
      <List
        items={items}
        renderItems={({ label, url, icon, id, requiresAuth }) => (
          <Link href={url} onClick={handleChangeBar(requiresAuth)}>
            <Flex
              direction={"col"}
              alignItems={"center"}
              justifyContent={"center"}
              gap={"1"}
            >
              <PhosphorIcon
                name={icon as keyof typeof PhosphorIcon}
                weight="bold"
                size={21}
                className={cn(
                  activeRoute === id ? "text-primary" : "text-muted-foreground",
                )}
              />
              <Typography
                variant="caption"
                className={cn(
                  activeRoute === id
                    ? "!font-bold text-primary"
                    : "font-normal text-muted-foreground",
                )}
              >
                {label}
              </Typography>
            </Flex>
          </Link>
        )}
      />
    </Flex>
  );
}
